import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { CircleCheck, OctagonAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { Toast } from '@/common/components/Toast'
import { api, ApiError } from '@/lib/axios'

type EditPasswordProps = {
  currentPassword: string
  newPassword: string
}

export async function editPassword(data: EditPasswordProps) {
  return api.backend.post('/user/change-password', data)
}

export function useEditPassword() {
  const { t } = useTranslation('profile')
  const { mutateAsync, isPending } = useMutation<
    unknown,
    AxiosError<ApiError>,
    EditPasswordProps
  >({
    mutationKey: ['editPassword'],
    mutationFn: editPassword,
    onSuccess: () => {
      toast(Toast, {
        data: {
          type: 'success',
          icon: CircleCheck,
          title: t('password.toast.success.title'),
          description: t('password.toast.success.message'),
        },
      })
    },
    onError: (error) => {
      toast(Toast, {
        data: {
          type: 'danger',
          icon: OctagonAlert,
          title: t('password.toast.error.title'),
          description:
            error?.response?.data?.friendlyMessage ||
            t('password.toast.error.message'),
        },
      })
    },
  })

  const handleEditPassword = async (data: EditPasswordProps) => {
    await mutateAsync({
      ...data,
    })
  }

  return {
    handleEditPassword,
    isPendingEditPassword: isPending,
  }
}
